import { Pipe, PipeTransform } from '@angular/core';

import { Entity } from '@rp/shared/models';

@Pipe({
  name: 'entityName',
  standalone: true,
})
export class EntityNamePipe implements PipeTransform {
  transform(id: number, entities: Entity[]): string {
    const found = entities.find(x => x.id === id);

    return found ? found.name : '—';
  }
}
